import api from '~/api'
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import { Notification } from 'element-ui'

const state = {
  providers: {},
  providersList: [],
  providerSearching: false,
}

const getters = {
  providers: s => get(s.providers, 'items', []),
  total: s => get(s.providers, 'pagination.total_items', 0),
  providerName: s => id => {
    const provider = s.providers.find(item => item.id === id)

    return provider ? provider.name : '—'
  },
}

const mutations = {
  SET_PROVIDERS(state, serverResponse) {
    state.providers = serverResponse
  },
  SET_PROVIDERS_LIST(state, payload) {
    state.providersList = payload
  },
  SET_SEARCHING(state, payload) {
    state.providerSearching = payload
  },
}

const actions = {
  async getProviders({ commit }) {
    const [error, result] = await api.get('/providers?perPage=1') // We only need to get Total

    if (result) {
      commit('SET_PROVIDERS', result)
    }

    return [error, result]
  },
  searchProviders: debounce(async function({ commit }, string) {
    commit('SET_SEARCHING', true)
    const [error, success] = await api.post(
      '/search/providers/_search?from=0&size=10',
      {
        query: {
          wildcard: { 'name.lowercase': `*${String(string)}*` },
        },
      }
    )

    let providersList = []

    if (error) {
      commit('SET_PROVIDERS_LIST', [])
      Notification({
        type: 'error',
        title: 'Error',
        message: error.message,
      })
    } else if (success) {
      providersList = get(success, 'hits.hits', []).map(item => {
        return { label: item._source.name, value: item._id, products: item._source.products }
      })
      commit('SET_PROVIDERS_LIST', providersList)
    }
    commit('SET_SEARCHING', false)
    return [error, providersList]
  }, 300),
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
